<template>
  <LoadingScreen
    v-if="loadingErrorMessage"
    :error-message="loadingErrorMessage"
  />
  <div v-else id="app">
    <template v-if="configVals">
      <!-- The actual app -->
      <TWarningBanner />
      <TopNavBar v-if="showNavBar" class="print:hidden print-hidden" />

      <!-- using the apiUrl as the key reloads the page on change -->
      <RouterView
        :key="configVals.apiUrl"
        class="h-px flex-1"
        :class="pageClasses"
      />
      <AmazonConnectGlobalWrapper />
      <RestrictedDialModal />
      <TutorialLauncher v-if="enableTutorials" :configs="wizardConfigs" />
    </template>
    <ErrorPage v-else class="page" :message="errorMessage" />
  </div>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from 'vue'
import { RouterView } from 'vue-router'
import TopNavBar from '@/legacy/components/TopNavBar/TopNavBar.vue'
import TWarningBanner from '@/legacy/nashville/menu/TWarningBanner/TWarningBanner.vue'
import RestrictedDialModal from '@/libs/features/phoneNumbers/RestrictedDialModal/RestrictedDialModal.vue'
import ErrorPage from '@/pages/Basic/ErrorPage/ErrorPage.vue'
import LoadingScreen from '@/pages/Basic/LoadingScreen/LoadingScreen.vue'
import { setup } from './controller'

export default defineComponent({
  components: {
    TopNavBar,
    TWarningBanner,
    RouterView,
    LoadingScreen,
    ErrorPage,
    RestrictedDialModal,
    AmazonConnectGlobalWrapper: defineAsyncComponent(
      () => import('@/tokens/amazonCCP/AmazonConnectGlobalWrapper.vue')
    ),
    TutorialLauncher: defineAsyncComponent(
      () =>
        import('@nashville/thymeWizard/TutorialLauncher/TutorialLauncher.vue')
    ),
  },
  setup,
})
</script>

<style scoped lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  @apply h-screen w-screen flex-col flex justify-stretch;
  // Old Browsers & Firefox
  height: 100vh;
  // Modern Browsers & Mobile
  // Fixes browser height issue on mobile
  // https://stackoverflow.com/a/70048720
  height: 100dvh;
}
</style>
